<template>
  <label class="agent-toggle-row" :class="{ 'is-disabled': disabled }">
    <span class="agent-toggle-copy">
      <strong>{{ label }}</strong>
      <small v-if="description">{{ description }}</small>
    </span>
    <toggle-switch
      :value="!!value"
      :disabled="disabled"
      :aria-label="label"
      @input="$emit('input', $event)"
    />
  </label>
</template>

<script>
import ToggleSwitch from "./ToggleSwitch.vue";

export default {
  name: "ToggleRow",
  components: {
    ToggleSwitch
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.agent-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-height: 42px;
  margin: 0;
  padding: 7px 0;
  color: #344054;
  cursor: pointer;
}
.agent-toggle-row.is-disabled {
  cursor: not-allowed;
  opacity: .6;
}
.agent-toggle-copy {
  min-width: 0;
}
.agent-toggle-copy strong {
  display: block;
  color: #344054;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}
.agent-toggle-copy small {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.45;
}
@media (max-width: 575px) {
  .agent-toggle-row {
    align-items: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ai/agentV2/components/ToggleRow.vue